import React from "react"
import { FormControlLabel, Switch, Typography } from "@material-ui/core"
import { ContactSubscriptionItem as ItemType } from "@ua/web-sdk/lib/remote-data/preference-center"
import { ItemProps } from "./types"

const ContactSubscriptionItem: React.FC<ItemProps<ItemType>> = ({
  item,
  onSubscribe,
  onUnsubscribe,
  isSubscribed,
}) => {
  return (
    <FormControlLabel
      control={
        <Switch
          data-qa-selector={`preference-center-subscription-${item.subscription_id}-checkbox`}
          checked={isSubscribed(item.subscription_id, item.scopes[0])}
          onChange={(ev) => {
            if (ev.target.checked) {
              onSubscribe(item.subscription_id, item.scopes[0])
            } else {
              onUnsubscribe(item.subscription_id, item.scopes[0])
            }
          }}
          name={item.subscription_id}
          color="primary"
        />
      }
      label={
        <>
          <Typography variant="body1">{item.display.name}</Typography>
          {item.display.description && (
            <Typography variant="caption">
              {item.display.description}
            </Typography>
          )}
        </>
      }
    />
  )
}

export default ContactSubscriptionItem
